import * as React from "react";
const IconCoinCopy = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M36 31h-7.4c-2.9 0-5.3-2.3-5.3-5 0-2.8 2.4-5 5.3-5h10.7c.6 0 1-.4 1-1s-.4-1-1-1H33v-3.8c0-.6-.4-1-1-1s-1 .4-1 1V19h-2.4c-4 0-7.3 3.2-7.3 7s3.3 7 7.3 7H36c2.9 0 5.3 2.3 5.3 5 0 2.8-2.4 5-5.3 5H24.8c-.6 0-1 .4-1 1s.4 1 1 1H31v3.8c0 .6.4 1 1 1s1-.4 1-1V45h3c4 0 7.3-3.2 7.3-7S40 31 36 31" />
    <path d="M32 2C15.5 2 2 15.5 2 32s13.5 30 30 30 30-13.5 30-30S48.5 2 32 2m0 58C16.6 60 4 47.4 4 32S16.6 4 32 4s28 12.6 28 28-12.6 28-28 28" />
  </svg>
);
export default IconCoinCopy;
